<!DOCTYPE html>
<html lang="ar" dir="rtl">

<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>نظام البلاغات</title>
</head>

<body>
    <div id="root"></div>
    <script type="module" src="./main.jsx"></script>
</body>

</html>